import { createSvgIcon } from '@mui/material';

export const Skills = createSvgIcon(
  <path d="M0.666748 8.99984C0.666748 4.39984 4.40008 0.666504 9.00008 0.666504C13.6001 0.666504 17.3334 4.39984 17.3334 8.99984C17.3334 13.5998 13.6001 17.3332 9.00008 17.3332C4.40008 17.3332 0.666748 13.5998 0.666748 8.99984ZM9.00008 13.9998C11.7584 13.9998 14.0001 11.7582 14.0001 8.99984C14.0001 6.2415 11.7584 3.99984 9.00008 3.99984C6.24175 3.99984 4.00008 6.2415 4.00008 8.99984C4.00008 11.7582 6.24175 13.9998 9.00008 13.9998Z" />,
  'TripOrigin',
);
